module.exports = __webpack_public_path__ + "static/media/amber-white-coat@3x.3d110cb3.png";